import React from 'react';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';

const Packages = (props) => {
    console.log(props)
    function handleBtnClick() {
        console.log('click')
    }
    return (
        <div className='packages-page'>
            <div className='packages-title-container'>
                <h1 className='title-black'>
                    {/* <div dangerouslySetInnerHTML={{ __html: props.subTitle }}></div> */}
                    {/* <span>יש לנו חדשות מעולות!</span> */}
                    {/* <span>שמנו לב שבכתובת החדשה יש אפשרות לעבור לאינטרנט על גבי סיב אופטי עד 1000mb !!!</span> */}
                    {/* <span dangerouslySetInnerHTML={{ __html: props.packagesTitle }}></span> */}
                </h1>
            </div>
            <div className='packages-title-bonus'>
                <span>ICON</span>
                <span>לכבוד מעבר דירה יש לנו הצעה מיוחדת</span>
            </div>
            <div className='packages-box-container'>
                <div className='packages-box'>
                    <span className='packages-box-title'>פייבר 1Gb</span>
                    <div className='packages-box-subTitle'>
                        <span>הורדה עד <span className='packages-box-subTitle-pink'>1000Mbps</span></span>
                        <span className='packages-box-space'>|</span>
                        <span>העלאה עד <span className='packages-box-subTitle-pink'>100Mbps</span></span>
                    </div>
                    <div className='packages-box-moreDetails'><a href='#'>לפרטים נוספים</a></div>
                    <div className='packages-box-blackSticker-container'>
                        <div className='packages-box-blackSticker'>
                            <span>ICON</span>
                            <span>נתב ללא תשלום לעוברים דירה באתר</span>
                        </div>
                    </div>
                    <div className='packages-box-price-container'>
                        <div className='packages-box-price-right'>

                            <span className='packages-box-bigPrice'>134</span>
                            <span className='packages-box-bigPrice-icon'>₪</span>

                        </div>
                        <div className='packages-box-price-left'>
                            <span className='packages-box-bigPrice'><span className='packages-box-lineThrough'>₪144</span> לחודש</span>
                            <span className='packages-box-bigPrice-icon'>מחיר מיוחד באתר</span>
                        </div>
                    </div>
                    <div className='packages-box-btn'>
                        <BtnSubmit
                            text={'אני מעוניין'}
                            onclick={() => { handleBtnClick }}
                            formid='moving'
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};
export default Packages;
